<template>
<div>
  <div class="card mb-4">
    <div class="card-body">
      <div class="float-left">
        <b-dropdown text="Download" variant="primary" v-if="searchForm.totalResults > 0" v-on:shown="jobsDropdownShown()" id="download-dropdown">
          <b-dropdown-item :disabled="tarButtonDisabled" v-if="searchForm.fileColumnIndex !== null" @click="createTar" id="create-tar">
            <font-awesome-icon icon="download" /> Create tar from selected
          </b-dropdown-item>
          <b-dropdown-item @click="createVOTable" id="create-vo-table">
            <font-awesome-icon icon="download" /> VOTable (all query results - {{searchForm.totalResults}} rows)
          </b-dropdown-item>
          <b-dropdown-item @click="createCSV" id="create-csv">
            <font-awesome-icon icon="download" /> CSV (all query results - {{searchForm.totalResults}} rows)
          </b-dropdown-item>
          <b-dropdown-item v-if="searchForm.fileColumnIndex !== null" @click="createURLs" id="create-url-list">
            <font-awesome-icon icon="download" /> URL list (all query results - {{searchForm.totalResults}} rows) .txt
          </b-dropdown-item>
          <a role="menuitem" href="token" target="_self" class="dropdown-item" v-if="searchForm.fileColumnIndex !== null && userLabel !== null">
            <font-awesome-icon icon="download" /> Command line access token
          </a>
        </b-dropdown>
        <a :href="tapUrl + '#' + encodeURIComponent(searchForm.query)" class="btn btn-secondary ml-3" v-if="searchForm.query !== ''" target="_blank" id="edit-query-btn">
          <font-awesome-icon icon="code" />
          Edit query
        </a>
        <a :href="dataCalibrationUrl + '#' + encodeURIComponent(searchForm.query)" class="btn btn-secondary ml-3" v-if="searchForm.query !== '' && dataCalibrationUrl !== '/'" target="_blank" id="get-cals-btn">
          <font-awesome-icon icon="code" />
          Get cals
        </a>
      </div>
      <div class="form-inline float-right">
        <label for="page-size"><strong>Rows displayed:</strong></label>
        <b-form-select id="page-size" v-model="searchForm.pageSize" :options="pageSizeOptions" v-on:change="changePageSize" class="ml-3"></b-form-select>
      </div>
    </div>
  </div>
  <div class="relative-wrapper">
    <div class="table-responsive" id="result-table-wrapper">
      <table class="table table-striped" v-if="searchForm.htmlRows !== ''" id="result-table">
        <ResultTableThead />
        <tbody v-html="searchForm.htmlRows"></tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div v-bind:class="{ 'col-7' : searchForm.totalResults > 0, 'col' : searchForm.totalResults === 0 }">
      <b-pagination v-model="searchForm.currentPage" :total-rows="searchForm.totalResults" :per-page="searchForm.pageSize" aria-controls="groups-list" align="center" v-on:change="changePage" v-if="searchForm.totalResults > 0"></b-pagination>
      <p class="text-center" v-if="searchForm.query">Total results: {{searchForm.totalResults}}</p>
    </div>
    <div class="col-4 text-center" v-if="searchForm.totalResults > 0">
      <b-input-group>
        <b-form-input placeholder="Page number..." type="number" v-model="pageNumber" v-on:keyup.enter="setPageNumber" v-on:change="resetPageNumberError" v-on:keydown="resetPageNumberError"></b-form-input>
        <b-input-group-append>
          <b-button variant="primary" @click="setPageNumber">Go to page</b-button>
        </b-input-group-append>
      </b-input-group>
      <span class="text-danger" v-if="pageNumberError">{{pageNumberError}}</span>
    </div>
  </div>
  <b-modal id="confirm-job" title="Confirm action" ok-title="Yes, proceed" @ok="confirmJobAction">
    <div class="text-center">
      <p>
        <font-awesome-icon icon="exclamation-triangle" />&nbsp;<strong>Are you sure?</strong>
      </p>
      <p>
        You are going to load a lot of records: {{searchForm.totalResults}} rows.<br />
        This action may take some time.
      </p>
    </div>
  </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import ResultTableThead from './ResultTableThead.vue';

const portalId = process.env.VUE_APP_PORTAL_ID || process.env.VUE_APP_PORTAL;
let dataCalibrationUrl = process.env.VUE_APP_DATA_CALIBRATION_URL || '';

function buildPageSizeOptions(values) {
  let options = [];
  for (var i = 0; i < values.length; i++) {
    let value = values[i];
    options.push({
      value: value,
      text: value.toString()
    });
  }
  return options;
}

export default {
  name: 'ResultTable',
  components: {
    ResultTableThead
  },
  data: function() {
    return {
      pageSizeOptions: buildPageSizeOptions([20, 50, 100, 200, 300, 500]),
      tarButtonDisabled: true,
      pageNumber: null,
      pageNumberError: null,
      lastJobType: null,
      portalId: portalId,
      dataCalibrationUrl: !dataCalibrationUrl.endsWith('/') ? dataCalibrationUrl += '/' : dataCalibrationUrl
    };
  },
  computed: mapState({
    searchForm: state => state.searchForm,
    tapUrl: state => state.tapUrl,
    userLabel: state => state.userLabel
  }),
  mounted() {
    window.addEventListener('resize', this.setTableHeight);
  },
  destroyed() {
    window.removeEventListener('resize', this.setTableHeight);
  },
  updated() {
    this.setTableHeight();
    this.generatePreviewPopovers();
  },
  methods: {
    setTableHeight() {
      let topMenuHeight = document.getElementById('top-menu').getBoundingClientRect().height;
      let maxTableHeight = window.innerHeight - topMenuHeight - 120;
      document.getElementById('result-table-wrapper').style.maxHeight = maxTableHeight + 'px';
    },
    generatePreviewPopovers() {
      let previewLinks = document.querySelectorAll('#result-table [data-preview-url]');
      for (let i = 0; i < previewLinks.length; i++) {
        let previewLink = previewLinks[i];
        if (!previewLink.getAttribute('data-popover-ref')) {
          previewLink.removeEventListener('mouseenter', showPopoverPreview);
          previewLink.addEventListener('mouseenter', showPopoverPreview);
          previewLink.removeEventListener('mouseleave', hidePopoverPreview);
          previewLink.addEventListener('mouseleave', hidePopoverPreview);
        }
      }
    },
    changePage(page) {
      this.$store.dispatch("changePage", page);
    },
    changePageSize(pageSize) {
      this.$store.dispatch("changePageSize", pageSize);
    },
    setPageNumber() {
      this.resetPageNumberError();
      if (this.pageNumber === null || this.pageNumber === '') {
        return;
      }
      let lastPage = Math.ceil(this.searchForm.totalResults / this.searchForm.pageSize);
      if (this.pageNumber > 0 && this.pageNumber <= lastPage) {
        this.$store.dispatch("changePage", this.pageNumber);
        this.pageNumber = null;
      } else {
        this.pageNumberError = "Invalid page";
      }
    },
    resetPageNumberError() {
      this.pageNumberError = null;
    },
    createTar() {
      let jobOptions = {
        type: 'TAR',
        files: []
      };
      document.querySelectorAll('#result-table input').forEach(input => {
        if (input.checked) {
          let a = input.closest('tr').querySelector('.file-url');
          jobOptions.files.push(a.getAttribute(['data-url']));
        }
      });
      this.$store.dispatch("newJob", jobOptions);
    },
    createVOTable() {
      this.newQueryJob("VO_TABLE");
    },
    createCSV() {
      this.newQueryJob("CSV");
    },
    createURLs() {
      this.newQueryJob("URLS_LIST");
    },
    newQueryJob(type) {
      this.lastJobType = type;
      let jobOptions = {
        type,
        searchModel: {
          fields: this.searchForm.lastSearchFields,
          sortingSequence: this.searchForm.sortingSequence,
          page: this.searchForm.currentPage,
          pageSize: this.searchForm.pageSize,
          searchOnlyInUserGroups: this.searchForm.searchOnlyInUserGroups
        },
        totalCount: this.searchForm.totalResults
      };
      if (this.searchForm.totalResults > 100000) {
        this.$bvModal.show('confirm-job');
      } else {
        this.$store.dispatch("newJob", jobOptions);
      }
    },
    confirmJobAction() {
      this.$store.dispatch("newJob", this.lastJobType);
    },
    jobsDropdownShown() {
      this.tarButtonDisabled = true;
      document.querySelectorAll('#result-table input').forEach(input => {
        if (input.checked) {
          this.tarButtonDisabled = false;
        }
      });
    }
  }
}

function showPopoverPreview(ev) {
  let previewLink = ev.target;

  let url = previewLink.getAttribute('data-preview-url');
  // Image version to avoid caching
  let version = new Date().getTime();
  url += '?v=' + version;

  // Popover unique id (used for removal)
  let id = Math.random().toString(36).substring(3);
  previewLink.setAttribute('data-popover-ref', id);

  let popover = document.createElement('div');
  popover.classList.add('popover', 'fade', 'show', 'bs-popover-right', 'preview-popover');
  popover.setAttribute('id', id);

  let popoverArrow = document.createElement('div');
  popoverArrow.classList.add('arrow');
  popover.appendChild(popoverArrow);

  let popoverBody = document.createElement('div');
  popoverBody.classList.add('popover-body');
  popover.appendChild(popoverBody);

  let img = document.createElement('img');
  img.setAttribute('width', '300');
  img.setAttribute('src', url);
  popoverBody.appendChild(img);

  let wrapperRect = document.getElementById('result-table-wrapper').getBoundingClientRect();
  let rect = previewLink.getBoundingClientRect();
  let left = rect.left - wrapperRect.left + rect.width + 5;
  let top = rect.top - wrapperRect.top - popover.getBoundingClientRect().height / 2;
  popover.style.top = top + 'px';
  popover.style.left = left + 'px';

  // append popover after link
  ev.target.insertAdjacentHTML("afterend", popover.outerHTML);
}

function hidePopoverPreview(ev) {
  let popoverId = ev.target.getAttribute('data-popover-ref');
  let popover = document.getElementById(popoverId);
  if (popover) {
    popover.remove();
  }
}
</script>

<style>
.relative-wrapper {
  position: relative;
}

#th-selection {
  min-width: 45px;
  padding-left: 3px;
  padding-right: 3px;
}

#result-table thead th,
td {
  white-space: nowrap;
}

#result-table-wrapper {
  overflow-y: auto;
}

#result-table-wrapper table {
  border-collapse: collapse;
  width: 100%;
}

#result-table > thead th {
  position: sticky;
  top: 0;
  background: #eee;
}

.preview-popover {
  max-width: 312px;
  position: absolute;
  display: inline-block;
}

.preview-popover .popover-body {
  padding: 5px;
  background: #fff;
}
</style>
